module.exports = __webpack_public_path__ + "media/images/FlashcardsBurst-iconsize-c1aa33b38d89e2228f1c49f4aed4f4bd.png";